export class MatStockLengthNotSupported extends Error {}
export class MatStockSizeNotSupported extends Error {}
export class MatStockShapeNotSupported extends Error {}
